// ============================================================================
// Global error boundary para SPAs Vanilla JS.
//
// Captura errores no manejados (síncronos y de promesas) para evitar que la
// app quede en estado roto (pantalla en blanco / congelada). Registra el
// error en consola y opcionalmente muestra un banner al usuario.
// ============================================================================

/**
 * Registra listeners globales de error y unhandledrejection.
 *
 * @param {{ mostrarBanner?: boolean, prefijo?: string }} [opciones]
 */
export function instalarErrorBoundary(opciones = {}) {
  const { mostrarBanner = true, prefijo = 'App' } = opciones;

  function manejar(mensaje, error) {
    console.error(`[${prefijo}] ${mensaje}:`, error);

    if (!mostrarBanner) return;

    // Evitar duplicados
    if (document.getElementById('pf-error-boundary')) return;

    const banner = document.createElement('div');
    banner.id = 'pf-error-boundary';
    banner.setAttribute('role', 'alert');
    Object.assign(banner.style, {
      position: 'fixed',
      bottom: '16px',
      left: '16px',
      right: '16px',
      zIndex: '99999',
      padding: '12px 16px',
      background: '#dc2626',
      color: '#fff',
      borderRadius: '8px',
      fontSize: '14px',
      fontFamily: 'system-ui, sans-serif',
      boxShadow: '0 4px 12px rgba(0,0,0,.25)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
    });

    banner.innerHTML =
      '<span>Ocurrió un error inesperado. Intenta recargar la página.</span>' +
      '<button style="background:none;border:1px solid #fff;color:#fff;border-radius:4px;' +
      'padding:4px 12px;cursor:pointer;font-size:13px;white-space:nowrap">Cerrar</button>';

    banner.querySelector('button').addEventListener('click', () => banner.remove());

    document.body.appendChild(banner);

    // Auto-remover después de 10 segundos
    setTimeout(() => banner.remove(), 10_000);
  }

  window.addEventListener('error', (event) => {
    manejar('Error no capturado', event.error ?? event.message);
  });

  window.addEventListener('unhandledrejection', (event) => {
    manejar('Promesa rechazada', event.reason);
  });
}
